/* Orelle Glow — interacciones (vanilla, sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.gc-reveal:not(.gc-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gc-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var items = document.querySelectorAll('[data-gc-parallax]');
    if (!items.length || reduceMotion) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var strength = parseFloat(el.getAttribute('data-gc-parallax')) || 0;
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * strength / 100;
        el.style.transform = 'translate3d(0,' + (-offset).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initTilt() {
    if (reduceMotion || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-gc-tilt]').forEach(function (card) {
      var frame = card.querySelector('.gc-gallery__frame') || card;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        frame.style.transform = 'rotateY(' + (x * 8).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg)';
      });
      card.addEventListener('mouseleave', function () { frame.style.transform = ''; });
    });
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-gc-product]').forEach(function (wrap) {
      if (wrap.dataset.gcReady) return;
      wrap.dataset.gcReady = '1';

      // Galería
      var main = wrap.querySelector('[data-gc-main]');
      var thumbs = wrap.querySelectorAll('[data-gc-thumb]');
      function showImage(src, srcset, alt, btn) {
        if (!main) return;
        main.classList.add('is-fading');
        setTimeout(function () {
          main.src = src;
          if (srcset) main.srcset = srcset;
          main.alt = alt || '';
          main.classList.remove('is-fading');
        }, 180);
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === btn); });
      }
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          showImage(btn.dataset.src, btn.dataset.srcset, btn.dataset.alt, btn);
        });
      });

      // Variantes
      var dataEl = wrap.querySelector('[data-gc-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = wrap.querySelector('input[name="id"]');
      var priceEl = wrap.querySelector('[data-gc-price]');
      var addBtn = wrap.querySelector('[data-gc-add]');
      var addLabel = addBtn ? addBtn.querySelector('[data-gc-add-label]') : null;
      var moneyFormat = wrap.dataset.moneyFormat || '{{amount}}';
      var txtAdd = wrap.dataset.textAdd || 'Add to cart';
      var txtSold = wrap.dataset.textSoldout || 'Sold out';
      var txtUnavailable = wrap.dataset.textUnavailable || 'Unavailable';

      function formatMoney(cents) {
        var value = (cents / 100).toFixed(2);
        var parts = value.split('.');
        var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        return moneyFormat
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDot)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
          .replace(/\{\{\s*amount\s*\}\}/, withComma);
      }

      function selectedOptions() {
        var values = [];
        wrap.querySelectorAll('[data-gc-option]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          var hidden = fs.querySelector('input[type="hidden"]');
          values[parseInt(fs.dataset.gcOption, 10)] = checked ? checked.value : (hidden ? hidden.value : null);
        });
        return values;
      }

      function update() {
        if (!variants.length) return;
        var opts = selectedOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] == null || opts[i] === o; });
        });
        if (!match) {
          if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = txtUnavailable; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) {
          var html = '<span>' + formatMoney(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<s>' + formatMoney(match.compare_at_price) + '</s>';
            if (priceEl.dataset.saleLabel) html += '<span class="gc-tag">' + priceEl.dataset.saleLabel + '</span>';
          }
          priceEl.innerHTML = html;
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          if (addLabel) addLabel.textContent = match.available ? txtAdd : txtSold;
        }
        if (match.featured_media && match.featured_media.preview_image) {
          var btn = wrap.querySelector('[data-gc-thumb][data-media-id="' + match.featured_media.id + '"]');
          if (btn) btn.click();
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
      wrap.querySelectorAll('[data-gc-option] input').forEach(function (inp) { inp.addEventListener('change', update); });

      // Cantidad
      var qty = wrap.querySelector('[data-gc-qty]');
      wrap.querySelectorAll('[data-gc-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qty) return;
          var v = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.gcQtyStep, 10));
          qty.value = v;
        });
      });

      // Añadir al carrito con el cajón de Dawn (si existe); si no, envío normal del formulario
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var errorEl = wrap.querySelector('[data-gc-error]');
      if (form && window.fetch) {
        form.addEventListener('submit', function (e) {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!cart || typeof cart.renderContents !== 'function') return; // envío normal → /cart
          e.preventDefault();
          if (errorEl) errorEl.textContent = '';
          addBtn.disabled = true;
          var fd = new FormData(form);
          if (typeof cart.getSectionsToRender === 'function') {
            fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
          }
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) {
              if (errorEl) errorEl.textContent = res.description || res.message || '';
              return;
            }
            cart.classList && cart.classList.remove('is-empty');
            cart.renderContents(res);
          }).catch(function () { form.submit(); })
            .finally(function () { addBtn.disabled = false; update(); });
        });
      }

      update();
    });
  }

  function initCountUp(root) {
    var els = (root || document).querySelectorAll('[data-gc-count]:not([data-gc-counted])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-gc-counted', '1');
      var target = parseFloat(el.getAttribute('data-gc-count')) || 0;
      var decimals = (String(el.getAttribute('data-gc-count')).split('.')[1] || '').length;
      var duration = parseInt(el.getAttribute('data-gc-duration'), 10) || 1600;
      if (reduceMotion) { el.textContent = target.toFixed(decimals); return; }
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initRoutine(root) {
    (root || document).querySelectorAll('[data-gc-routine]').forEach(function (wrap) {
      if (wrap.dataset.gcRoutineInit) return;
      wrap.dataset.gcRoutineInit = '1';
      var tabs = wrap.querySelectorAll('[data-gc-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          wrap.setAttribute('data-mode', tab.dataset.gcTab);
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      });
    });
  }

  function initFinder(root) {
    (root || document).querySelectorAll('[data-gc-finder]').forEach(function (wrap) {
      if (wrap.dataset.gcFinderInit) return;
      wrap.dataset.gcFinderInit = '1';
      var tabs = wrap.querySelectorAll('[data-gc-ftab]');
      var panels = wrap.querySelectorAll('[data-gc-fpanel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.dataset.gcFtab;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.dataset.gcFpanel === id;
            p.classList.toggle('is-active', on);
            p.hidden = !on;
          });
        });
      });
    });
  }

  function initAll(root) {
    initReveal(root);
    initProduct(root);
    initCountUp(root);
    initRoutine(root);
    initFinder(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initParallax();
    initTilt();
  });
  // Editor de Shopify: re-inicializa al añadir/editar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initTilt(); });
})();
